const tokenExpiryErrorCode = ['999-999'];

export const tokenExpiryErrorCheck = (errorCode: string): boolean => {
  if (tokenExpiryErrorCode.includes(errorCode)) {
    return true;
  }

  return false;
};
